import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SiteNav from "components/Redesign/SiteNav.js";
import SiteFooter from "components/Redesign/SiteFooter.js";
import SwissMap, { LOCATIONS } from "components/Redesign/SwissMap.js";
import heroImg from "assets/img/ueberuns/wabe.jpg";
import geschichteImg from "assets/img/ueberuns/3_imker_tessin.jpeg";
import teamFaleraImg from "assets/img/ueberuns/team-falera.jpg";
import teamRobinLisaImg from "assets/img/ueberuns/team-robin-lisa.jpg";
import teamDachlissenImg from "assets/img/ueberuns/team-dachlissen.jpg";
import teamRobertKastenImg from "assets/img/ueberuns/team-robert-kasten.jpg";
import teamScharmfangImg from "assets/img/ueberuns/team-scharmfang.jpg";
import teamTrudiImg from "assets/img/team/trudi.jpg";

/*
 * Über uns — Übersichtsseite (Hub) für "Unsere Geschichte" und
 * "Unsere Standorte". Beide Kind-Seiten sind aktuell noch Platzhalter-
 * Shells; ihr Inhalt folgt in einem separaten Schritt.
 */
function UeberUns() {
  const { t } = useTranslation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rd">
      <SiteNav />

      <div className="hero-banner">
        <img src={heroImg} alt="Bienen auf der Wabe" className="hero-banner-img" />
      </div>

      <div className="ueberuns-intro">
        <div className="wrap">
          <div className="rd-section-no">{t("ueberuns.Page label")}</div>
          <h1>{t("ueberuns.Page title")}</h1>
        </div>
      </div>

      <section>
        <div className="wrap">
          <div className="ueberuns-split">
            <div className="ueberuns-teaser">
              <div className="ueberuns-teaser-label">{t("ueberuns.Geschichte teaser label")}</div>
              <h2>{t("ueberuns.Geschichte teaser title")}</h2>
              <div className="ueberuns-visual">
                <img src={geschichteImg} alt="Familie Bühler bei der Bienenkontrolle im Tessin" />
              </div>
              <div className="ueberuns-teaser-body">
                <p>{t("ueberuns.Geschichte teaser body p1")}</p>
                <p>{t("ueberuns.Geschichte teaser body p2")}</p>
              </div>
              <Link to="/ueber-uns/unsere-geschichte" className="cta-secondary">
                {t("ueberuns.Geschichte teaser cta")} <span className="arr">→</span>
              </Link>
            </div>

            <div className="ueberuns-teaser">
              <div className="ueberuns-teaser-label">{t("ueberuns.Standorte teaser label")}</div>
              <h2>{t("ueberuns.Standorte teaser title")}</h2>
              <div className="ueberuns-map">
                <SwissMap width={220} />
                <ul className="ueberuns-map-legend">
                  {Object.keys(LOCATIONS).map(key => (
                    <li key={key}>{LOCATIONS[key].name}</li>
                  ))}
                </ul>
              </div>
              <div className="ueberuns-teaser-body">
                <p>{t("ueberuns.Standorte teaser body p1")}</p>
                <p>{t("ueberuns.Standorte teaser body p2")}</p>
              </div>
              <Link to="/ueber-uns/unsere-standorte" className="cta-secondary">
                {t("ueberuns.Standorte teaser cta")} <span className="arr">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="ueberuns-team">
        <div className="wrap">
          <div className="rd-section-no">{t("ueberuns.Team label")}</div>
          <h2>{t("ueberuns.Team title")}</h2>
          <div className="ueberuns-team-photos">
            <div className="ueberuns-team-row-hero">
              <div className="ueberuns-team-photo ueberuns-team-photo-hero">
                <img src={teamFaleraImg} alt="Zwei Imker bei der Arbeit an den Bienenstöcken in Falera" loading="lazy" />
              </div>
              <div className="ueberuns-team-photo ueberuns-team-photo-center">
                <img src={teamRobinLisaImg} alt="Zwei Imker im Bienenanzug lachen in die Kamera" loading="lazy" />
              </div>
              <div className="ueberuns-team-photo ueberuns-team-photo-small">
                <img src={teamTrudiImg} alt="Trudi Bühler im Bienenanzug" loading="lazy" />
              </div>
            </div>
            <div className="ueberuns-team-row-grid">
              <div className="ueberuns-team-photo">
                <img src={teamDachlissenImg} alt="Zwei Imker im Bienenanzug auf der Wiese in Dachlissen" loading="lazy" />
              </div>
              <div className="ueberuns-team-photo">
                <img src={teamRobertKastenImg} alt="Robert Bühler bei den Bienenkästen im Tessin" loading="lazy" />
              </div>
              <div className="ueberuns-team-photo">
                <img src={teamScharmfangImg} alt="Christoph und Robert beim Schwarmfang im Tessin" loading="lazy" />
              </div>
            </div>
          </div>
          <div className="ueberuns-team-body">
            <p>{t("ueberuns.Team body p1")}</p>
            <p>{t("ueberuns.Team body p2")}</p>
            <p>{t("ueberuns.Team body p3")}</p>
            <p>{t("ueberuns.Team body p4")}</p>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}

export default UeberUns;
